import axios from "axios";
import Cookies from "js-cookie";
import apiUrl from "../utility/apiUrl";

// Same authHeaders() pattern as ShortlistService.js - raw token value (not Bearer-prefixed)
// under the Authorization header.
const authHeaders = () => ({ Authorization: Cookies.get("token") });

export const getNotifications = (page = 0, size = 20) =>
  axios.get(`${apiUrl}/api/v1/student/notifications`, {
    params: { page, size },
    headers: authHeaders(),
  });

export const getUnreadCount = () =>
  axios.get(`${apiUrl}/api/v1/student/notifications/unread-count`, { headers: authHeaders() });

export const markNotificationRead = (id) =>
  axios.post(`${apiUrl}/api/v1/student/notifications/${id}/read`, null, { headers: authHeaders() });

export const markAllNotificationsRead = () =>
  axios.post(`${apiUrl}/api/v1/student/notifications/mark-all-read`, null, { headers: authHeaders() });
